import { Ord, fromCompare, contramap } from 'fp-ts/Ord';
import { Ord as stringOrd } from 'fp-ts/string';

export const ordNumberDesc: Ord<number> = fromCompare((x, y) =>
  x > y ? -1 : x < y ? 1 : 0,
);
export const byAmountDesc: Ord<{ amount: number }> = fromCompare((x, y) =>
  ordNumberDesc.compare(x.amount, y.amount),
);

export const byName = contramap((x: Record<'name', string>) => x.name)(
  stringOrd,
);

export const idOrd = contramap((x: Record<'id', string>) => x.id)(stringOrd);

export const byVoteTypeName: Ord<string> = fromCompare((x, y) => {
  if (y === 'motm') {
    return 1;
  }
  if (y === 'dotd') {
    return -1;
  }
  return stringOrd.compare(x, y);
});

export const byVoteType: Ord<{ name: string }> = contramap(
  (voteType: { name: string }) => voteType.name,
)(byVoteTypeName);

export const byVoteVoteType = contramap(
  (vote: Record<'voteType', { name: string }>) => vote.voteType,
)(byVoteType);
